/**
 * gamesis Notification Model
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EventNotification { 
    campaign: string;
    campaignLabel: string;
    recipients: Set<string>;
    character?: string;
    eventType: string;
}

